import { useGetPages } from "../hooks/useGetPages"
import _ from "lodash"
export default function ConvertSlug(page_id, slug, page_title) {
  let active_slug = slug
  let page_name = ""
  // Get all pages
  let all_pages = useGetPages()
  // Get parent service category to set slug
  if (all_pages) {
    page_name = all_pages.edges.find(
      page => page.node.frontmatter.page_id === page_id
    )
    // If page_name exists, update slug
    if (page_name) {
      active_slug = `/${_.kebabCase(
        page_name.node.frontmatter.title
      )}/${_.kebabCase(page_title)}/`
    }
  }
  return active_slug
}
